import { useQuery } from '@apollo/client';

import DegreesByDomainQuery from 'bundles/unified-description-page-common/queries/DegreesByDomainQuery.graphql';
import type {
  DescriptionPage_DegreesByDomain_LearningProductFragment as DegreesByDomainLearningProduct,
  DescriptionPage_DegreesByDomainQuery as DegreesByDomainQueryData,
  DescriptionPage_DegreesByDomainQueryVariables as DegreesByDomainQueryVariables,
} from 'bundles/unified-description-page-common/queries/__generated__/DegreesByDomainQuery';
import { previewXdpAsADiscoveryToolVariant } from 'bundles/unified-description-page-common/utils/xdpAsADiscoveryToolUtils';

export type DegreesByDomainData = {
  degrees: Array<DegreesByDomainLearningProduct>;
  degreesLoading: boolean;
};

const useDegreesByDomain = (domains: string[]): DegreesByDomainData => {
  const inXdpAsADiscoveryToolExperiment = previewXdpAsADiscoveryToolVariant() !== 'control';

  const { data, loading } = useQuery<DegreesByDomainQueryData, DegreesByDomainQueryVariables>(DegreesByDomainQuery, {
    context: { clientName: 'gatewayGql' },
    variables: {
      domains,
    },
    skip: !domains?.length || !inXdpAsADiscoveryToolExperiment,
  });

  return {
    degrees: data?.PremiumProductCollections?.queryCollection?.filter(Boolean) ?? [],
    degreesLoading: loading,
  };
};

export default useDegreesByDomain;
